import type { InventoryItem } from '../types/inventory.types';

/**
 * N11 zorunlu alanlarını kontrol eder
 * @param item - Stok ürünü
 * @param getBrandName - Marka adını getiren fonksiyon
 * @returns Validasyon sonucu ve eksik alanlar listesi
 */
export const validateN11RequiredFields = (
  item: InventoryItem,
  getBrandName: (brandId: string | null) => string
): { isValid: boolean; missingFields: string[] } => {
  const missingFields: string[] = [];

  // Ürün adı (zorunlu)
  if (!item.name || item.name.trim().length === 0) {
    missingFields.push('Ürün Adı');
  }

  // Marka (zorunlu)
  const brandName = getBrandName(item.brandId || null);
  if (!item.brandId || brandName === '-' || brandName.trim().length === 0) {
    missingFields.push('Marka');
  }

  // Stok kodu (zorunlu)
  if (!item.stockCode || item.stockCode.trim().length === 0) {
    missingFields.push('Stok Kodu');
  }

  // Satış fiyatı (zorunlu ve 0'dan büyük)
  if (!item.salePrice || item.salePrice <= 0) {
    missingFields.push('Satış Fiyatı');
  }

  // Miktar (zorunlu ve 0'dan büyük)
  // ✅ YENİ SİSTEM: WarehouseStocks'tan toplam hesapla
  const totalQuantity = item.warehouseStocks?.reduce((sum, ws) => sum + ws.quantity, 0) || 0;
  if (!totalQuantity || totalQuantity <= 0) {
    missingFields.push('Stok Miktarı');
  }

  // Açıklama (zorunlu)
  if (!item.description || item.description.trim().length === 0) {
    missingFields.push('Ürün Açıklaması');
  }

  return {
    isValid: missingFields.length === 0,
    missingFields
  };
};

